import { render } from "./MinersSection.vue?vue&type=template&id=1b316f1c"
import script from "./MinersSection.vue?vue&type=script&lang=js"
export * from "./MinersSection.vue?vue&type=script&lang=js"

import "./MinersSection.vue?vue&type=style&index=0&id=1b316f1c&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__